import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { JsonService } from '@services/jsons/json.service';
import { ScreenService } from '@services/screens/screen.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';

@Component({
    selector: 'app-json-read-only',
    templateUrl: './json-read-only.component.html',
    styleUrls: ['./json-read-only.component.scss'],
    providers: [JsonService, ScreenService, AngieScreensService],
    standalone: false
})
export class JsonReadOnlyComponent implements OnInit {

  pageActions: PageAction[];
  title = 'Custom Json: ';
  isLoading = true;
  boundJson: Models.FakeJSON;
  screen: any;
  screenPath = 'screens';
  jsonId: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private jsonService: JsonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private screenService: ScreenService,
    private angieScreensService: AngieScreensService,
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.jsonId = this.activatedRoute.snapshot.params['id'];
      this.jsonService.get(this.activatedRoute.snapshot.params['id']).then(json => {
        this.boundJson = json;
        this.fetchScreen(this.boundJson.screenUUID).then(() => {
          this.title += this.screen.name + ' ' + this.boundJson.language;
        });
        this.createPageActions();
        this.isLoading = false;
      });
    }
  }

  fetchScreen(uuid) {
    return this.screenService.find(0, 1, { uuid: uuid }).then(screen => {
      if (!screen || !screen.data || !screen.data.length) {
        return this.angieScreensService.find(0, 1, { uuid: uuid }).then(angieScreen => {
          this.screenPath = 'angie-screens';
          this.screen = angieScreen.data && angieScreen.data.length ? angieScreen.data[0] : null;
        });
      }
      this.screen = screen.data[0];
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'Overview Screen',
        callback: () => {
          this.router.navigate([this.screenPath, this.screen._id]);
        }
      }),
      new PageAction({
        icon: 'settings',
        title: 'Screen Settings',
        callback: () => {
          this.router.navigate(['screen-settings', this.screen.uuid]);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit JSON',
        callback: () => {
          this.router.navigate(['jsons', this.jsonId, 'edit']);
        }
      })
    ];
  }

}
